// extracted by mini-css-extract-plugin
export default {"title":"FormSection_title__4JHSj","description":"FormSection_description__gcb5H"};